import { gql } from '@apollo/client'
import userError from '../fragments/userError'

const CHANGE_USER_LOCALE = gql`
  mutation ChangeUserLocale($input: ChangeUserLocaleInput!) {
    changeUserLocale(input: $input) {
      user {
        id
      }
      errors {
        ...userError
      }
    }
  }

  ${userError}
`

export default CHANGE_USER_LOCALE
